import {alert} from '@pnotify/core';

export function catchDispatchErrorMsg(error) {
  if (error && error === 'XhrError') {
    return 'Error: Network Error';
  } else if (error && error.response) {
    if (error.response.status === 403) {
      return this.$t('home.error403');
    } else if (error.response.status === 422) {
      this.errors && this.errors.clear();
      if (error.response.data.errors) {
        let message = [];
        Object.keys(error.response.data.errors).map(field => {
          const messages = error.response.data.errors[field];
          this.errors.add(this.id + '.' + field, this.$t(messages[0]), 'server');
          message.push(this.$t(messages[0]));
        });
        return message.join('<br>')
      } else {
        return error.response.data.message ||
          error.response.data.error ||
          error.response.data.status ||
          error.response.data ||
          error.response.status;
      }
    } else if (error.response.data) {
      return error.response.data.message ||
        error.response.data.error ||
        error.response.data.status ||
        error.response.data ||
        error.response.status;
    }
  } else if (error) {
    return error.toString();
  }

  return 'no error data';
}


export default function (error) {
  console.error('catchDispatch' +
    ' | this = ', this,
    ' | e = ', error,
    ' | typeof e = ', typeof error,
    ' | e.response = ', error && error.response);

  if (this.loading) this.loading = false;

  const title = this.$t('home.error');
  const text = catchDispatchErrorMsg.call(this, error);
  const addClass = 'bg-danger text-white';

  alert({title, text, addClass});
}
